import '@/index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/contexts/AuthContext';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import Services from '@/pages/Services';
import Partners from '@/pages/Partners';
import FinancialTools from '@/pages/FinancialTools';
import Blogs from '@/pages/Blogs';
import BlogDetail from '@/pages/BlogDetail';
import Login from '@/pages/Login';
import ClientPortal from '@/pages/ClientPortal';
import Career from '@/pages/Career';
import Testimonials from '@/pages/Testimonials';
import Contact from '@/pages/Contact';
import ServiceDetail from '@/pages/ServiceDetail';
import AdminPanel from '@/pages/AdminPanel';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:serviceId" element={<ServiceDetail />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/financial-tools" element={<FinancialTools />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:slug" element={<BlogDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/portal" element={<ClientPortal />} />
            <Route path="/career" element={<Career />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
        </Layout>
        <Toaster position="top-center" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
